import { render } from "./FltrosPesquisa.vue?vue&type=template&id=3d3959b0&lang=true"
import script from "./FltrosPesquisa.vue?vue&type=script&lang=js"
export * from "./FltrosPesquisa.vue?vue&type=script&lang=js"

import "./FltrosPesquisa.vue?vue&type=style&index=0&id=3d3959b0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__